import React from "react";
import _ from "lodash";

import {Grid, makeStyles} from "@material-ui/core";

import {InstrumentsFilter} from "../../../../../../../../../../Modelportfolios/components";
import PrimaryButton from "../../../../../../../../../../../components/Buttons/PrimaryButton";

const useStyles = makeStyles(theme => ({
  header: {
    fontSize: 15,
    fontFamily: 'Roboto-Bold'
  },
}))

const AssetsSelectionPage = ({
  instrumentsHandler,
  assetsSearch,
  handleSearchActivate,
  assets,
  instrumentsSources,
  handleAddAssetClick,
  instrumentsSearchDisabled,
  handleFiltersExtendedButtonClick,
  isCustomerApp,
  children,
}) => {
  const classes = useStyles();

  const filterInstruments = React.useMemo(() => {

    if (assetsSearch.loading || assetsSearch.errors || !assetsSearch.data) {
      return undefined
    }

    if (!instrumentsHandler) {
      return assetsSearch.data
    }

    let [instrumentsToAccept, instrumentsToExclude] = instrumentsHandler.filterInstruments(assetsSearch.data);

    return {
      "accepted": instrumentsToAccept,
      "excluded": instrumentsToExclude
    }

  }, [assetsSearch.date]);

  return (
    <div style={{padding: '18px 0'}}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <InstrumentsFilter
            title={"Produkt suchen:"}
            instruments={filterInstruments}
            instrumentsDisabled={assets}
            loading={assetsSearch.loading}
            errors={assetsSearch.errors}
            onSearchActivate={handleSearchActivate}
            onAddAssetClick={handleAddAssetClick}
            onFiltersExtendedButtonClick={handleFiltersExtendedButtonClick}
            disabled={instrumentsSearchDisabled}
            isCustomerApp={isCustomerApp}
            WidgetProps={{
              style: {
                boxShadow: 'none'
              }
            }}
            customClasses={{productSearchLabel: classes.header}}
          />
        </Grid>
        {!_.isEmpty(instrumentsSources) && (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} className={classes.header}>Aus Vorauswahl wählen:</Grid>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  {instrumentsSources.map(btn => (
                    <Grid item key={btn.text}>
                      <PrimaryButton
                        text={btn.text}
                        variant={btn.variant}
                        disabled={btn.disabled}
                        onButtonClick={btn.onButtonClick}
                        tooltip={btn.tooltip}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}

        {children}
      </Grid>
    </div>
  )
}

export default AssetsSelectionPage;